import React from 'react';
import classes from './StrideProfile.module.css';
import { useTranslation } from 'react-i18next';
import { AppUtils, Services, Utilities } from '@gscope-mfe/app-bridge';
import { MaterialUiCore } from '@gscope-mfe/common-libs';
import Loader from '../../../Loader';
import LogoutModal from '../../../LogoutModal/LogoutModal';

const { Button } = MaterialUiCore;
const { setUserPreference } = Utilities;

const StrideProfile = ({ profileTab, origin, setShowProfile }) => {
    const { allLangs, prefLang, setPrefLang, logoutHandler, supportedlngs } = AppUtils.get();
    const [showLang, setShowLang] = React.useState(false);
    const [isLoading, setIsLoading] = React.useState(false);
    const [langChosen, setLangChosen] = React.useState();
    const [modalShow, setModalShow] = React.useState(false);
    const { t, i18n } = useTranslation('commonLang');
    const profileRef = React.useRef();
    const languageRef = React.useRef();
    const langSelectorRef = React.useRef();
    const showLanguageSelector = () => {
        setShowLang(true);
    };
    const changeLangChosen = (language) => {
        setLangChosen(language);
    };
    const applyLanguage = () => {
        if (langChosen !== prefLang.current) {
            i18n.changeLanguage(langChosen).then(() => {
                setPrefLang && setPrefLang({ previous: prefLang.current, current: langChosen });
            });
            const reqPayload = {
                pageName: 'appPreferences',
                key: 'prefLang',
                value: { lang: langChosen },
            };
            setUserPreference(reqPayload);
            setShowProfile(false);
        }
    };
    const logoutModalHandler = () => {
        setShowLang(false);
        setModalShow(true);
    };
    React.useEffect(() => {
        if (profileRef && profileRef.current) {
            if (origin == 'ExpandedPanel') {
                profileRef.current.style.bottom = window.innerHeight - profileTab.current.offsetTop + 'px';
                profileRef.current.style.left = profileTab.current.getBoundingClientRect().left + 'px';
            } else profileRef.current.style.top = window.innerHeight - profileRef.current.offsetHeight + 3 + 'px';
        }
    }, []);
    React.useEffect(() => {
        if (prefLang && prefLang.current) {
            setLangChosen(prefLang.current);
        }
    }, [prefLang]);

    React.useEffect(() => {
        if (showLang && langSelectorRef) {
            langSelectorRef.current.style.bottom =
                window.innerHeight - languageRef.current.getBoundingClientRect().bottom + 'px';
            langSelectorRef.current.style.left = languageRef.current.getBoundingClientRect().right + 'px';
        }
    }, [showLang]);
    return (
        <React.Fragment>
            <Loader show={isLoading} />
            <div ref={profileRef} className={classes.pageContainer} style={{ visibility: 'visible' }}>
                <div className={classes.overflownModuleTitle}>
                    <span>{t('myProfile')}</span>
                </div>
                {allLangs && allLangs.length > 0 && (
                    <div
                        className={classes.overflownModule}
                        data-testid="LangSelector"
                        ref={languageRef}
                        onClick={showLanguageSelector}
                    >
                        <i className={`${classes['sct-icon']} icon-Globe-181x sct-icon`}></i>
                        <span>{t('language')}</span>
                        <i
                            style={{ marginLeft: 'auto' }}
                            className={`${classes['sct-icon']} sct-icon icon-Arrow-Right-18`}
                        ></i>
                    </div>
                )}
                <div className={classes.overflownModule} onClick={logoutModalHandler}>
                    <i className={`${classes['sct-icon']} icon-Sign-out sct-icon`}></i>
                    <span>{t('logout')}</span>
                    <i
                        style={{ marginLeft: 'auto' }}
                        className={`${classes['sct-icon']} sct-icon icon-Arrow-Right-18`}
                    ></i>
                </div>
            </div>
            {showLang && allLangs.length > 0 && (
                <div
                    data-testid="languageOverflow"
                    className={classes.pageContainer}
                    style={{ position: 'absolute' }}
                    ref={langSelectorRef}
                >
                    {allLangs.map((lang, i) => {
                        return (
                            <div
                                data-testid={`langOption${i}`}
                                onClick={() => changeLangChosen(lang)}
                                className={
                                    langChosen == lang
                                        ? `${classes.overflownModule} ${classes.currentSelection}`
                                        : classes.overflownModule
                                }
                            >
                                {' '}
                                <span>{supportedlngs[lang] ? supportedlngs[lang] : lang.toLowerCase()} </span>
                            </div>
                        );
                    })}
                    <div className={classes.overflownModuleButtons}>
                        <Button
                            data-testid="cancelProfile"
                            style={{ textDecoration: 'underline' }}
                            onClick={() => setShowLang(false)}
                        >
                            {t('cancel')}
                        </Button>
                        <Button
                            data-testid="applyProfile"
                            style={{ background: '#0071dc', color: 'white', borderRadius: '16px' }}
                            onClick={applyLanguage}
                        >
                            {t('apply')}
                        </Button>
                    </div>
                </div>
            )}
            <LogoutModal
                data-testid="logout-Mod"
                modalShow={modalShow}
                setModalShow={setModalShow}
                logoutHandler={logoutHandler}
            />
        </React.Fragment>
    );
};
export default StrideProfile;
